export const WORDS_TO_SHOW_MORE = 11;
